import DebouncedInput from "@/components/DebouncedInput";
import SelectFilter from "@/components/SelectFilter";
import { SimpleGrid } from "@chakra-ui/react";
import { useCallback } from "react";
import { mapPayoutStatus } from "../../mappers/payouts.mapper";
import type { PayoutsFiltersType } from "../../types/payouts.type";

interface Props {
  queryFilters: PayoutsFiltersType;
  setQueryFilters: React.Dispatch<React.SetStateAction<PayoutsFiltersType>>;
}

export default function BatchItemsFilters({
  queryFilters,
  setQueryFilters,
}: Props) {
  const handleDocumentNumberChange = useCallback(
    (value: string) =>
      setQueryFilters((prev) => ({ ...prev, customerDocumentNumber: value })),
    [setQueryFilters]
  );

  const handleIdChange = useCallback(
    (value: string) => setQueryFilters((prev) => ({ ...prev, id: value })),
    [setQueryFilters]
  );

  return (
    <SimpleGrid columns={{ base: 1, sm: 3 }} gap={3} mb={4}>
      <DebouncedInput
        placeholder="No. Documento"
        size="sm"
        value={queryFilters.customerDocumentNumber}
        onDebouncedChange={handleDocumentNumberChange}
      />
      <DebouncedInput
        placeholder="ID del pago"
        size="sm"
        value={queryFilters.id}
        onDebouncedChange={handleIdChange}
      />
      <SelectFilter
        isClearable
        options={Object.keys(mapPayoutStatus)}
        selectedOption={queryFilters.status}
        onSelect={(option) =>
          setQueryFilters((prev) => ({ ...prev, status: option }))
        }
        placeholder="Estado"
      />
    </SimpleGrid>
  );
}
